// User Agent del scanner de OneTrust enviado por Karol el 24/11/2025
// Fuente: Email "Topic 2 - User Agent to Use"
const ONETRUST_SCANNER_USER_AGENT = 'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/120.0.6099.199 Safari/537.36;OneTrust;'
// Función para detectar si el visitante es el scanner de OneTrust
export const isOneTrustScanner = (): boolean => {
  const userAgent = navigator.userAgent || ''
  // Detectar el User Agent EXACTO del scanner
  // Verificamos si el UA contiene el identificador clave ";OneTrust;"
  return userAgent.includes(';OneTrust;') || userAgent === ONETRUST_SCANNER_USER_AGENT
}